module.exports = __webpack_public_path__ + "img/img-success.76d65041.png";